import { ActionDescription, MeraActionDescription } from 'app/shared/enum';

export class bookingUpdateData {
  private saveBookingList: any[] = [];
  copyReplaceArray: any = [];

  public checkMergeBooking(element, booking, diary) {
    const isMergeBookingExists = element.WeeklyBookings.filter(
      (currBook) =>
        currBook.ParentBookingID === booking.ActualBookingId &&
        currBook.ActionMode === 'D'
    );
    if (isMergeBookingExists && isMergeBookingExists.length > 0) {
      // Create delete requests for the merged cells
      isMergeBookingExists.forEach((eachBook) => {
        eachBook.id = eachBook.ActualBookingId;
        eachBook.beforeEditHours = eachBook.ActualBookingHours;
        eachBook.beforeEditPercentage =
          (Number(eachBook.ActualBookingHours) / diary) * 100;
        eachBook.isDelete = true;
        this.bookingsToSave(eachBook);
      });
    }
  }

  public checkSplitBooking(element, booking) {
    const isSplitBookingExists = element.WeeklyBookings.filter(
      (currBook) =>
        currBook.ActualBookingId === booking.ActualBookingId &&
        currBook.ActionMode === 'E'
    );
    // Find min and Max dates
    if (isSplitBookingExists && isSplitBookingExists.length > 0) {
      isSplitBookingExists.forEach((splitBook) => {
        if (
          splitBook.BookingId === 0 &&
          (splitBook.MeraBookingId === 1 || splitBook.MeraBookingId === 0)
        ) {
          //check MeraBookingID==0
          if (
            splitBook.BookingHours === null ||
            splitBook.BookingHours === ''
          ) {
            //Delete scenario of new bookings created for Block Booking,
            splitBook.isDelete = true;
            booking.MeraActionDescriptionId = MeraActionDescription.Delete;
          } else {
            //Edit, Replace scenario of Block Booking
            splitBook.isEdited = false;
            splitBook.isNewBooking = true;
            if (
              booking.MeraActionDescriptionId === MeraActionDescription.Replace
            ) {
              splitBook.JobId = booking.JobId;
              splitBook.ResourceId = booking.ResourceId;
            }
            splitBook.MeraActionDescriptionId = MeraActionDescription.Create;
          }
          this.bookingsToSave(splitBook);
        } else if (splitBook.BookingId === booking.ActualBookingId) {
          //Booking with actual entry in Retain.(block booking)
          if (booking.BookingId === 0) {
            if (booking.BookingHours === null || booking.BookingHours === '') {
              splitBook.isEdited = true;
              splitBook.MeraActionDescriptionId = MeraActionDescription.Edit;
            }
            if (
              booking.MeraActionDescriptionId === MeraActionDescription.Edit
            ) {
              splitBook.isEdited = true;
              splitBook.MeraActionDescriptionId = MeraActionDescription.Edit;
            }
          }

          this.bookingsToSave(splitBook);
          // if (
          //   splitBook.BookingHours === null ||
          //   splitBook.BookingHours === ''
          // ) {
          //   splitBook.isDelete = true;
          //   splitBook.MeraActionDescriptionId = 4;
          // } else {
          //   splitBook.isDelete = true;
          //   splitBook.isEdited = false;
          //   splitBook.MeraActionDescriptionId = 4;
          //   let newBooking = JSON.parse(JSON.stringify(splitBook));
          //   newBooking.id = newBooking + 'split';
          //   newBooking.BookingId = 0;
          //   newBooking.ActualBookingId = 0; //splitBook.ActualBookingId
          //   newBooking.isNewBooking = true;
          //   newBooking.MeraActionDescriptionId = 1;
          //   this.bookingsToSave(newBooking);
          // }
        }
      });
    }
  }

  public bookingsToSave(booking) {
    // if(booking.isCanacelRequested === true){
    //     booking.isCancelRequested = false;
    // }
    let actionID;
    let meraActionID;
    if (
      booking.isNewBooking &&
      !booking.isCopied &&
      booking.Loading !== null &&
      booking.BookingHours !== null
    ) {
      actionID = ActionDescription.Create;
      meraActionID = MeraActionDescription.Create;
      if (
        booking.BookingId === 0 &&
        booking.ActualBookingId !== 0 &&
        booking.IsSplitBooking
      ) {
        booking.isNewBooking = false;
      }
    } else if (
      booking.isNewBooking &&
      booking.isCopied &&
      booking.Loading !== null &&
      booking.BookingHours !== null
    ) {
      actionID = ActionDescription.Copy;
      meraActionID = MeraActionDescription.Copy;
    } else if (booking.isEdited) {
      actionID = ActionDescription.Edit;
      meraActionID = MeraActionDescription.Edit;
    } else if (booking.isDelete || booking.ActionMode === 'D') {
      actionID = ActionDescription.Delete;
      meraActionID = MeraActionDescription.Delete;
    } else if (booking.rowReplaced) {
      actionID = ActionDescription.Replace;
      meraActionID = MeraActionDescription.Replace;
    }
    const param = {
      id: booking.id,
      BookingId: booking.BookingId,
      ResourceId: booking.ResourceId,
      JobId: booking.JobId,
      BookingType: booking.BookingType,
      StartDate: booking.StartDate,
      EndDate: booking.WeekEndDate,
      Description: booking.Description,
      Hours:
        meraActionID === 4
          ? parseFloat(booking.beforeEditHours)
          : booking.BookingHours,
      ComponentDescr: booking.ComponentDescr || null,
      JobAssignmentDescr: booking.JobAssignmentDescr || null,
      Loading:
        meraActionID === 4
          ? parseFloat(booking.beforeEditPercentage)
          : booking.Loading,
      Unconfirmed: booking.Unconfirmed,
      Ghost: booking.Ghost,
      IsOverallocation: booking.IsOverallocation,
      ActionDescriptionId: actionID,
      InstanceId: booking.InstanceId,
      MeraActionDescriptionId: meraActionID,
      ActualBookingId: booking.ActualBookingId,
      ParentBookingId: booking.ParentBookingID,
    };
    if (
      param.Hours === null ||
      param.Hours === '' ||
      param.Hours === 0
    ) {
      return false;
    }
    let indexToReplace = null;
    if (this.saveBookingList.length > 0) {
      this.saveBookingList.map((editedBookings, index) => {
        if (editedBookings.id === param.id) {
          indexToReplace = index;
        }
      });
      if (indexToReplace !== null) {
        if (
          booking.isNewBooking &&
          booking.Loading === null &&
          booking.BookingHours === null
        ) {
          this.saveBookingList.splice(indexToReplace, 1);
        } else if (booking.revertAction === true) {
          this.saveBookingList.splice(indexToReplace, 1);
          booking.revertAction = false;
        } else {
          this.saveBookingList[indexToReplace] = param;
        }
      } else {
        if (
          booking.isNewBooking &&
          booking.Loading !== null &&
          booking.BookingHours !== null
        ) {
          this.saveBookingList.push(param);
        } else if (
          booking.revertAction === false ||
          booking.revertAction === undefined
        ) {
          if (!booking.isNewBooking) {
            this.saveBookingList.push(param);
          }
        } else if (booking.revertAction === true) {
          booking.revertAction = false;
        }
      }
    } else {
      if (
        booking.revertAction === false ||
        booking.revertAction === undefined
      ) {
        this.saveBookingList.push(param);
      } else {
        booking.revertAction = false;
      }
    }
    console.log(this.saveBookingList);
  }

  public removeEngagement(element) {
    this.saveBookingList = this.saveBookingList.filter((item) => {
      return (
        item.JobId + item.InstanceId !== element.JobId + element.InstanceID
      );
    });
  }
  public removeBooking(booking) {
    this.saveBookingList = this.saveBookingList.filter(item => item.id !== booking.id);
    console.log('After Cancel', this.saveBookingList)
  }
  public fetchSaveDataList = () => {
    return this.saveBookingList;
  };

  public clearSaveDataList = () => {
    this.saveBookingList = [];
  };

  public setCopyReplaceArray = (item, param?) => {
    if (param && param === 'eng') {
      const doesExists = this.copyReplaceArray.findIndex(
        (res) =>
          res.MeraActionDescriptionId === MeraActionDescription.Replace &&
          res.ToResourceId === item.ToResourceId
      );
      if (doesExists > -1) {
        this.copyReplaceArray.splice(doesExists, 1);
      }
    } else if (param && param === 'res') {
      const doesExists = this.copyReplaceArray.findIndex(
        (eng) =>
          eng.MeraActionDescriptionId === MeraActionDescription.Replace &&
          eng.ToJobId === item.ToJobId
      );
      if (doesExists > -1) {
        this.copyReplaceArray.splice(doesExists, 1);
      }
    }
    this.copyReplaceArray.push(item);
  };

  public deleteItemFromCopyReplaceArray = (element) => {
    this.copyReplaceArray = this.copyReplaceArray.filter(
      (item) => !(item.FromJobId === element.JobId)
    );
  };

  public clearCopyReplaceArray = () => {
    this.copyReplaceArray = [];
  };

  public getCopyReplaceArray = () => {
    return this.copyReplaceArray;
  };
}
